import { SVGProps, Ref, forwardRef } from 'react';

export const BubbleRoundDoubleOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.5 11.394V9.491a6 6 0 0 1-1.02-.497C2.42 8.339 1.8 7.433 1.8 6c0-1.502.683-2.445 1.887-3.114C4.998 2.157 6.902 1.8 9 1.8s4.002.357 5.313 1.086c1.122.623 1.791 1.484 1.877 2.814h1.803C17.797 1.433 13.4 0 9 0 4.5 0 0 1.5 0 6c0 2.937 1.917 4.596 4.5 5.394m11.55 9.04v-2.68l-1.731-.067c-1.963-.075-3.676-.477-4.838-1.193C8.419 15.839 7.8 14.933 7.8 13.5c0-1.502.683-2.445 1.887-3.114C10.998 9.657 12.902 9.3 15 9.3s4.002.357 5.313 1.086c1.204.669 1.887 1.612 1.887 3.114 0 1.39-1.061 2.905-3.09 4.622-.955.807-2.01 1.569-3.06 2.313M15 7.5c4.5 0 9 1.5 9 6 0 3.515-4.014 6.355-7.245 8.64-.94.666-1.815 1.285-2.505 1.86v-4.514C10.013 19.324 6 17.75 6 13.5c0-4.5 4.5-6 9-6"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
BubbleRoundDoubleOutlinedSize24Glyph.displayName = 'BubbleRoundDoubleOutlinedSize24Glyph';
